'use strict';

/**
* Adds a floating label effect to input fields
* @returns {void}
*/
function floatingInputLabel() {
    // INPUTS
    $('.form-label-floating input').on('focus  change keyup', function () {
        $(this).parent().addClass('show-label');
    }).on('blur', function () {
        if ($(this).val() === '') {
            $(this).parent().removeClass('show-label');
        }
    });

    // SELECTS
    $('.form-label-floating select').on(' updated change', function () {
        if ($(this).val() === '') {
            $(this).parent().removeClass('show-label');
        } else {
            $(this).parent().addClass('show-label');
        }
    });

    $('.form-label-floating input,.form-label-floating select').each(function () {
        if (this.value !== null && this.value !== '') {
            $(this).parent().addClass('show-label');
        }
    });
}

window.addEventListener('load', function () {
    floatingInputLabel();
});
